import { Reset, Theme } from "@bluframe/blublocks"
import Button from "components/buttons/Button"
import styled from "styled-components"

export const Wrapper = styled.div`
  background-color: ${({ theme }: { theme: Theme }) =>
    theme.palette.text.contrast};
  display: grid;
  gap: 12px;
  padding: 20px;
  width: 100%;
`

export const ActivityToggleButton = styled(Button)`
  color: ${({ theme }: { theme: Theme }) => theme.palette.text.main};
  grid-template-columns: 1fr auto;
  justify-content: start;
  justify-items: start;
  text-align: left;

  &:hover,
  &:focus-visible {
    color: ${({ theme }: { theme: Theme }) => theme.palette.text.main};
  }

  & > span:first-child {
    display: none;
  }

  & > :last-child {
    justify-self: end;
  }
`

export const ActivityList = styled(Reset.Ul)`
  display: grid;
  row-gap: 8px;
`

export const ActivityItem = styled(Reset.Li)``
